import { emptySetcxexqki71qfa as emptySet } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  emptyList1g2z5xcrvp2zy as emptyList,
  listOfNotNull1v4ggfackvuny as listOfNotNull,
} from '../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import {
  toString1pkumu07cwy4m as toString,
  equals2au1ep9vhcato as equals,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  joinToString1cxrrlmo0chqs as joinToString,
  plus310ted5e4i90h as plus,
  first58ocm7j58k3q as first,
} from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import {
  checkIndexOverflow3frtmheghr0th as checkIndexOverflow,
  listOfvhqybd2zx248 as listOf,
  mapCapacity1h45rc3eh9p2l as mapCapacity,
  copyToArray2j022khrow2yi as copyToArray,
} from '../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { addAll1k27qatfgp3k5 as addAll } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/MutableCollections.mjs';
import { coerceAtLeast2bkz8m9ik7hep as coerceAtLeast } from '../../../../kotlin-kotlin-stdlib/kotlin/ranges/_Ranges.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import {
  CLASS_getInstance14ex35co4jkrb as CLASS_getInstance,
  OBJECT_getInstance26229tfe4t547 as OBJECT_getInstance,
} from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialKinds.mjs';
import { JsonNames3i9ju5gyx18ko as JsonNames } from '../../../../kotlinx-serialization-kotlinx-serialization-json/kotlinx/serialization/json/JsonAnnotations.mjs';
import { buildClassSerialDescriptors2a6xdp6mrtw as buildClassSerialDescriptor } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialDescriptors.mjs';
import { deferua88pnmsrho6 as defer } from '../serialization/SerializationHelpers.mjs';
import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import {
  default308h22k6ofhww as default_0,
  DefaultDecoder2zttto7bkrb7s as DefaultDecoder,
} from '../serialization/Defaults.mjs';
import { SerializationExceptioneqrdve3ts2n9 as SerializationException } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializationExceptions.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var OptionClass;
function Option() {
  if (OptionClass === VOID) {
    class $ {
      constructor(serializer, alternativeNames, annotations, isInstance) {
        var tmp;
        if (alternativeNames === VOID) {
          // Inline function 'kotlin.collections.setOf' call
          tmp = emptySet();
        } else {
          tmp = alternativeNames;
        }
        alternativeNames = tmp;
        var tmp_0;
        if (annotations === VOID) {
          // Inline function 'kotlin.collections.listOf' call
          tmp_0 = emptyList();
        } else {
          tmp_0 = annotations;
        }
        annotations = tmp_0;
        this.d49_1 = serializer;
        this.e49_1 = alternativeNames;
        this.f49_1 = annotations;
        this.g49_1 = isInstance;
      }
    }
    initMetadataForClass($, 'Option');
    OptionClass = $;
  }
  return OptionClass;
}
function getIndex($this, item) {
  var tmp0 = $this.t3t();
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.collections.indexOfFirst' call
    var index = 0;
    var _iterator__ex2g4s = tmp0.m1();
    while (_iterator__ex2g4s.n1()) {
      var item_0 = _iterator__ex2g4s.o1();
      if (item_0.g49_1(item)) {
        tmp$ret$1 = index;
        break $l$block;
      }
      index = index + 1 | 0;
    }
    tmp$ret$1 = -1;
  }
  // Inline function 'kotlin.also' call
  var this_0 = tmp$ret$1;
  if (this_0 === -1) {
    var tmp = $this.k49_1.h10();
    var tmp_0 = toString(getKClassFromExpression(item));
    var tmp_1 = $this.t3t();
    throw IllegalStateException().o4('No serializer inside ' + tmp + ' found for ' + tmp_0 + '; options are ' + joinToString(tmp_1, VOID, VOID, VOID, VOID, VOID, MySealedClassSerializer$getIndex$lambda));
  }
  return this_0;
}
function MySealedClassSerializer$_get_options_$ref_rhb6tc() {
  return (p0) => p0.t3t();
}
function MySealedClassSerializer$getIndex$lambda(it) {
  return it.d49_1.az().h10();
}
var MySealedClassSerializerClass;
function MySealedClassSerializer() {
  if (MySealedClassSerializerClass === VOID) {
    class $ {
      constructor(serialName, options, annotations) {
        var tmp;
        if (annotations === VOID) {
          // Inline function 'kotlin.collections.listOf' call
          tmp = emptyList();
        } else {
          tmp = annotations;
        }
        annotations = tmp;
        this.h49_1 = annotations;
        this.i49_1 = lazy(options);
        var tmp_0 = this;
        tmp_0.j49_1 = lazy(() => {
          // Inline function 'kotlin.collections.flatMapIndexed' call
          var tmp0 = this.t3t();
          // Inline function 'kotlin.collections.flatMapIndexedTo' call
          var destination = ArrayList().w();
          var index = 0;
          var _iterator__ex2g4s = tmp0.m1();
          while (_iterator__ex2g4s.n1()) {
            var element = _iterator__ex2g4s.o1();
            var _unary__edvuaz = index;
            index = _unary__edvuaz + 1 | 0;
            var index_0 = checkIndexOverflow(_unary__edvuaz);
            // Inline function 'kotlin.collections.map' call
            var this_0 = plus(listOf(element.d49_1.az().h10()), element.e49_1);
            // Inline function 'kotlin.collections.mapTo' call
            var destination_0 = ArrayList().u(collectionSizeOrDefault(this_0, 10));
            var _iterator__ex2g4s_0 = this_0.m1();
            while (_iterator__ex2g4s_0.n1()) {
              var item = _iterator__ex2g4s_0.o1();
              var tmp$ret$1 = to(item, index_0);
              destination_0.v(tmp$ret$1);
            }
            var list = destination_0;
            addAll(destination, list);
          }
          // Inline function 'kotlin.collections.associate' call
          var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(destination, 10)), 16);
          // Inline function 'kotlin.collections.associateTo' call
          var destination_1 = LinkedHashMap().fc(capacity);
          var _iterator__ex2g4s_1 = destination.m1();
          while (_iterator__ex2g4s_1.n1()) {
            var element_0 = _iterator__ex2g4s_1.o1();
            // Inline function 'kotlin.collections.plusAssign' call
            destination_1.s3(element_0.af_1, element_0.bf_1);
          }
          return destination_1;
        });
        var tmp_1 = this;
        var tmp_2 = CLASS_getInstance();
        tmp_1.k49_1 = defer(serialName, tmp_2, () => buildClassSerialDescriptor(serialName, [], ($this$buildClassSerialDescriptor) => {
          $this$buildClassSerialDescriptor.ez_1 = this.h49_1;
          var iterator = this.t3t().m1();
          var index = 0;
          while (iterator.n1()) {
            var index_0 = index;
            index = index + 1 | 0;
            var s = iterator.o1();
            var tmp0_elementName = s.d49_1.az().h10();
            var tmp1_descriptor = s.d49_1.az();
            // Inline function 'kotlin.let' call
            // Inline function 'kotlin.collections.toTypedArray' call
            var this_0 = this.t3t().q1(index_0).e49_1;
            var tmp$ret$11 = copyToArray(this_0);
            var tmp$ret$13 = new (JsonNames())(tmp$ret$11.slice());
            var tmp2_annotations = plus(listOfNotNull(tmp$ret$13), s.f49_1);
            $this$buildClassSerialDescriptor.g12(tmp0_elementName, tmp1_descriptor, tmp2_annotations, true);
          }
          return Unit_instance;
        }));
      }
      t3t() {
        var tmp0 = this.i49_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('options', 1, tmp, MySealedClassSerializer$_get_options_$ref_rhb6tc(), null);
        return tmp0.f2();
      }
      az() {
        return this.k49_1;
      }
      pz(decoder) {
        if (decoder instanceof DefaultDecoder())
          return default_0(first(this.t3t()).d49_1);
        // Inline function 'kotlinx.serialization.encoding.decodeStructure' call
        var descriptor = this.k49_1;
        var composite = decoder.l13(descriptor);
        var index = composite.b14(this.k49_1);
        if (index === -1) {
          throw SerializationException().p10('Single key expected, but received none.');
        }
        if (index === -3)
          throw SerializationException().p10('Unknown key received.');
        var serializer = this.t3t().q1(index).d49_1;
        var tmp;
        if (equals(serializer.az().s11(), OBJECT_getInstance())) {
          composite.n13(this.k49_1, index);
          tmp = default_0(serializer);
        } else {
          tmp = composite.y13(this.k49_1, index, serializer);
        }
        var result = tmp;
        if (!(composite.b14(this.k49_1) === -1))
          throw SerializationException().p10('Single key expected, but received multiple.');
        var result_0 = result;
        composite.m13(descriptor);
        return result_0;
      }
      lz(encoder, value) {
        // Inline function 'kotlinx.serialization.encoding.encodeStructure' call
        var descriptor = this.k49_1;
        var composite = encoder.l13(descriptor);
        var index = getIndex(this, value);
        var tmp = this.t3t().q1(index).d49_1;
        var serializer = isInterface(tmp, KSerializer()) ? tmp : THROW_CCE();
        if (equals(serializer.az().s11(), OBJECT_getInstance())) {
          composite.s14(this.k49_1, index, true);
        } else {
          composite.c15(this.k49_1, index, serializer, value);
        }
        composite.m13(descriptor);
      }
      oz(encoder, value) {
        return this.lz(encoder, !(value == null) ? value : THROW_CCE());
      }
    }
    initMetadataForClass($, 'MySealedClassSerializer', VOID, VOID, [MySealedClassSerializerInterface()]);
    MySealedClassSerializerClass = $;
  }
  return MySealedClassSerializerClass;
}
var MySealedClassSerializerInterfaceClass;
function MySealedClassSerializerInterface() {
  if (MySealedClassSerializerInterfaceClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'MySealedClassSerializerInterface', VOID, VOID, [KSerializer()]);
    MySealedClassSerializerInterfaceClass = $;
  }
  return MySealedClassSerializerInterfaceClass;
}
//region block: exports
export {
  Option as Optionfkzl7z5pdoc9,
  MySealedClassSerializerInterface as MySealedClassSerializerInterface2tzma5kn4becp,
  MySealedClassSerializer as MySealedClassSerializer11mxzpb8qyqe6,
};
//endregion

//# sourceMappingURL=MySealedClassSerializer.mjs.map
